// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"475":"5a3a51bc","861":"c067ec72","878":"c961f772","930":"9e15bc8e","948":"d1495cbc"}[chunkId] + ".chunk.js";
};